<nav *ngIf="breadcrumbs && breadcrumbs.length > 0" [attr.aria-label]="'breadcrumb.label' | translate">
  <ol class="d-none d-md-flex">
    <li *ngFor="let breadcrumb of breadcrumbs; let last = last">
      <a [href]="breadcrumb.url" [attr.aria-current]="last ? 'page' : null">{{ breadcrumb.label | translate }}</a>
    </li>
  </ol>
</nav>
<a *ngIf="previousBreadcrumb" [href]="previousBreadcrumb.url" class="d-lg-none small-screen-link">
  <mat-icon [svgIcon]="SvgIcon.ChevronLeft"></mat-icon>
  {{ 'breadcrumb.back_to' | translate : {label: (previousBreadcrumb.label | translate) } }}
</a>
